import './app.scss';
import Login from './login/dxPopupLogin';
import uaMessages from "./external/dxMessages.json";
import { locale, loadMessages } from "devextreme/localization";
import { SettingsProvider } from './context/settings-context';
import { ErrorProvider } from './context/error-context';
import ToastError from './common/toast-error';
import Messages from './messages/messages-container';
import Header from './header/header';
import moment from 'moment';
import 'moment/locale/uk';
import RedirectToHttps from './common/redirect';
import { AccountProvider } from './context/account-context';

const clearCacheData = () => {
    caches.keys().then((names) => {
        names.forEach((name) => {
            caches.delete(name)
        })
    })
}

loadMessages(uaMessages);
locale("ua");
moment.locale('uk');

export default function App() {

    return (
        <div className="App">
            <RedirectToHttps></RedirectToHttps>
            <ErrorProvider>
                <SettingsProvider>
                    <AccountProvider>
                        <ToastError></ToastError>
                        <Header></Header>
                        <Login></Login>
                        <Messages></Messages>
                    </AccountProvider>
                </SettingsProvider>
            </ErrorProvider>

        </div>
    );
}


